import styled from 'styled-components'
import { Flex } from '@vtex/shoreline'

type ContainerProps = {
  padding: string | undefined
}

export const Container = styled(Flex)<ContainerProps>`
  background-color: var(--sl-bg-base-soft);
  border-radius: var(--sl-radius-2);

  padding-top: ${(props) => props.padding || 'var(--sl-space-4)'};
  padding-bottom: ${(props) => props.padding || 'var(--sl-space-4)'};
`
